import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadSpecialization () {
    const api = getApiClient(this.$store)
    const specializationId = this.$route.params.id

    api.get(`specializations/${specializationId}`)
      .then(result => {
        this.specialization = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.specialization.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'specializations'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.specialization['@id']
    }

    api[method](endpoint, this.specialization, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Especialização salva com sucesso')
        this.$router.push({
          name: 'Specializations',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar especialização')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
